<template>
  <ul class="anwser_box">
    <li
      v-for="item in list"
      :key="item.id"
      :class="{ grey: boardType === 'BOARD' && item?.level != 1 }"
    >
      <div class="user_info p16" v-if="boardType === 'KNOWHOW'">
        <div class="profile_box">
          <div
            class="profile_img pnt"
            @click="goShopDetail(item.answerStore.storeId)"
          >
            <img
              :src="item.answerStore.storeProfile"
              alt=""
              v-if="item.answerStore.storeProfile"
            />
            <img
              :src="
                setShopProfileImg(
                  item.answerStore.storeName,
                  item.answerStore.storeId,
                )
              "
              alt=""
              v-else
            />
            <img
              v-if="item.answerStore.cert === 1"
              class="mark"
              src="@/assets/front/images/new/icon_consent_s.png"
            />
          </div>
          <div class="info knowhow">
            <p class="name">{{ item.answerStore.storeName }}</p>
            <p>
              <span class="ttl">상담</span>
              <span>{{ item.answerStore.chatCnt }}건</span>
              <span class="ttl">평가</span>
              <span
                >{{ Number(item.answerStore.evaluationScore).toFixed(1) }}점({{
                  item.answerStore.reviewCnt
                }}건)</span
              >
            </p>
          </div>
          <i class="i_reply_more pnt" @click="fnMore(item)"></i>
        </div>
      </div>
      <div class="user_info p16" v-else>
        <div
          class="profile_box spare-06"
          v-if="item.isDel === 'N' && item.isReport === 'N'"
        >
          <!-- <div class="info board"> -->
          <p class="nick">{{ item.writer }}</p>
          <p class="writer" v-if="item.userId == userId">
            <i class="dot"></i>
            <span>글쓴이</span>
          </p>
          <!-- </div> -->
          <i class="i_reply_more pnt" @click="fnMore(item)"></i>
        </div>
      </div>

      <div class="article_content p16" v-if="boardType === 'BOARD'">
        <p class="txt" v-if="item.isDel === 'N'">
          {{ item.contents }}
        </p>
        <p class="txt disable" v-else-if="item.isDel === 'Y'">
          해당 답글은 작성자에 의해 삭제되었습니다.
        </p>
        <p class="txt disable" v-else-if="item.isReport === 'Y'">
          해당 답글은 신고에 의해 숨김 처리되었습니다.
        </p>
        <div class="img_box small" v-if="item.images?.length > 0">
          <img
            v-for="image in item.images"
            :key="image.id"
            :src="image.imagePath"
            alt=""
          />
        </div>
      </div>
      <div class="article_content p16" v-else>
        <p class="txt">
          {{ item.contents }}
        </p>
        <div class="img_box small" v-if="item.images?.length > 0">
          <img
            class="pnt"
            v-for="(image, index) in item.images"
            :key="image.id"
            :src="image.imagePath"
            alt=""
            @click="viewImage(item.images, index)"
          />
        </div>
      </div>
      <div class="info_zone p16">
        <div class="sec_2">
          <div class="left">
            <span class="light">{{ item.createdAt | moment('from') }}</span>
            <span
              ><i
                class="pnt"
                :class="`i_reply_like_${item.isLike === 'Y' ? 'on' : 'off'}`"
                @click="fnLike(item.id)"
              ></i
              >{{ item.likeCnt }}</span
            >
          </div>
          <div class="right" v-if="boardType === 'KNOWHOW'">
            <span class="color pnt" v-if="!isOwner" @click="fnChat(item)"
              ><i class="i_reply_chat"></i>상담하기</span
            >
            <span class="pnt" @click="fnReply(item)">답글달기</span>
          </div>
          <div class="right" v-else>
            <span
              class="pnt"
              @click="fnReply(item)"
              v-if="
                item.level === 1 && item.isDel === 'N' && item.isReport === 'N'
              "
              >답글달기</span
            >
          </div>
        </div>
      </div>
      <hr />
      <!-- 지식인 답글 영역 -->
      <SectionComment
        v-if="item.replies?.length > 0"
        :board-type="boardType"
        :list="item.replies"
        :user-id="userId"
        :store-id="item.storeId"
        @like="fnLikeComm"
        @more="fnMoreComm"
      />
    </li>
    <MultipleImageModal
      ref="multipleImageModal"
      :is-open="isShowImageModal"
      :urls="clickedImageUrls"
      :index="clickedImageIndex"
      @close="closeImageModal"
    />
  </ul>
</template>

<script>
import * as util from '@common/lib/common/utils.js';

import SectionComment from '@common/components/community/detail/SectionComment';
import MultipleImageModal from '@/common/components/modal/MultipleImage.vue';
import 'swiper/swiper.scss';

import {
  sleep,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
} from '@common/lib/common/utils';

export default {
  name: 'component-community-detail-section-anwser',
  description: '커뮤니티 > 답변 영역',
  components: {
    SectionComment,
    MultipleImageModal,
  },
  props: {
    boardType: {
      type: String,
      default: 'KNOWHOW',
      description: 'KNOWHOW: 지식인, BOARD: 자유게시판',
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
    list: Array,
    userId: Number,
  },
  data() {
    return {
      isShowImageModal: false,
      clickedImageUrls: [],
      clickedImageIndex: 0,
    };
  },
  methods: {
    fnMore(item) {
      if (!this.isOwner) {
        if (item.isMine === 'Y') {
          this.$emit('more', 'COMME_EDIT', item);
        } else {
          this.$emit('more', 'COMME_REPORT', item);
        }
      } else {
        if (item.isMine === 'Y') {
          this.$emit('more', 'POST_EDIT', item);
        } else {
          this.$emit('more', 'POST_REPORT', item);
        }
      }
    },
    fnMoreComm(item) {
      if (item.isMine === 'Y') {
        this.$emit('more', 'COMME_EDIT', item);
      } else {
        this.$emit('more', 'COMME_REPORT', item);
      }
    },
    fnChat(item) {
      this.$emit('chat', item);
    },
    fnReply(item) {
      this.$emit('reply', item);
    },
    fnLike(id) {
      const found = this.list.filter(item => item.id === id);
      this.$emit('like', found[0], 'REPLY');
    },
    fnLikeComm(item) {
      this.$emit('like', item, 'COMMENT');
    },
    goShopDetail(shopId) {
      if (this.isOwner) return;
      this.$router.push({
        name: 'Shops.Detail',
        params: { id: shopId },
        //   query: { bottomBtn: 'hidden' },
      });
    },
    viewImage(images, idx) {
      this.isShowImageModal = true;
      this.clickedImageUrls = images;
      this.clickedImageIndex = idx;
      this.$refs.multipleImageModal.imageClickIndex = idx;
      nativeDisableBackKey();
    },
    closeImageModal() {
      this.isShowImageModal = false;
      this.clickedImageUrls = [];
      this.clickedImageIndex = 0;
      nativeEnableBackKey();
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '100x100', '18');

      return path;
    },
  },
};
</script>

<style></style>
